import { Component, Input } from '@angular/core';
import { marketingBlogEntity, marketingContentStatusEntity, marketingSocialPostEntity } from 'mj_generatedentities';

/**
 * Programs / Social — composes the existing SocialQueueSectionComponent which already handles
 * company posts vs employee opt-in reposts (with self-loaded profile photos for opted-in employees).
 * Per mockup: employee-generated posts demarcated visually from company posts.
 *
 * State flows down from the workspace shell — this section doesn't load its own data.
 */
@Component({
    standalone: false,
    selector: 'mkt-ws-programs-social',
    template: `
<mkt-ws-page-head
    [eyebrow]="'Programs · Social' + (companyName ? ' · ' + companyName : '')"
    title="Every post is agent-drafted. You approve, edit, or reject."
    sub="Sidecar LinkedIn Company page, opted-in employee profiles, and the always-on remixer. Nothing publishes without approval.">
</mkt-ws-page-head>

<div *ngIf="isLoadingContent" class="ps__loading">
    <i class="fa-solid fa-spinner fa-spin"></i> Loading social posts…
</div>

<mkt-ws-coming-soon
    *ngIf="!isLoadingContent && socialPosts.length === 0"
    icon="fa-share-nodes"
    title="No social posts yet"
    body="When the agent drafts social posts they'll appear here. Trigger 'Marketing - Social Post Drafts' from Foundation → Activity Log to generate some.">
</mkt-ws-coming-soon>

<mkt-social-queue-section
    *ngIf="!isLoadingContent && socialPosts.length > 0"
    [blogs]="blogs"
    [socialPosts]="socialPosts"
    [contentStatuses]="contentStatuses"
    [companyId]="companyId">
</mkt-social-queue-section>
    `,
    styles: [`
        :host { display: block; }
        .ps__loading { padding: 60px 20px; text-align: center; color: var(--mj-text-secondary, #71717a); }
    `]
})
export class ProgramsSocialSection {
    @Input() companyId = '';
    @Input() companyName = '';
    @Input() blogs: marketingBlogEntity[] = [];
    @Input() socialPosts: marketingSocialPostEntity[] = [];
    @Input() contentStatuses: marketingContentStatusEntity[] = [];
    @Input() isLoadingContent = false;
    @Input() navigate: (path: string) => void = () => {};
}
